<form nz-form nzLayout="vertical" [formGroup]="form" (ngSubmit)="handleOk()">
  <app-psd-fields [form]="form"/>
</form>
